module.exports = __webpack_public_path__ + "static/oil-tank-removal-single-03e817892b2f2f97791ccfd9b9da6a85.jpg";